import { render } from "./NavigationBar.vue?vue&type=template&id=05f5c8f7&ts=true"
import script from "./NavigationBar.vue?vue&type=script&lang=ts"
export * from "./NavigationBar.vue?vue&type=script&lang=ts"

import "./NavigationBar.vue?vue&type=style&index=0&id=05f5c8f7&lang=css"

import exportComponent from "/home/schulz/philipp-schulz.dev/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__